import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import {toast, ToastContainer} from 'react-toastify';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import {SignIn} from "aws-amplify-react";
import {I18n, JS} from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import AmplifyTheme from '../../themes/AmplifyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';

import Logo from "../../assets/img/logo-square-on-white.svg";

class CustomSignIn extends SignIn
{
    constructor(props)
    {
        super(props);
        this.checkContact = this.checkContact.bind(this);
        this.signIn = this.signIn.bind(this);

        this._validAuthStates = ['signIn', 'signedOut', 'signedUp'];
        this.state = {};
    }

    checkContact(user)
    {
        if (!Auth || typeof Auth.verifiedContact !== 'function')
        {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }

        /* Check if user is in group */
        const tokenPayload = user.signInUserSession.idToken.payload;

        Auth.verifiedContact(user)
            .then(data =>
            {
                if (!JS.isEmpty(data.verified))
                {
                    if (tokenPayload["cognito:groups"])
                    {
                        if (tokenPayload["cognito:groups"].includes("admins"))
                        {
                            this.changeState('signedIn', user);
                        } else
                        {
                            toast.error("Sie haben keine Berechtigungen für diesen Bereich.");
                            Auth.signOut()
                                .then(() =>
                                {
                                    this.changeState('signedOut');
                                })
                                .catch((error) =>
                                {
                                    return error;
                                })
                        }
                    } else
                    {
                        toast.error("Sie haben keine Berechtigungen für diesen Bereich.");
                        Auth.signOut()
                            .then(() =>
                            {
                                this.changeState('signedOut');
                            })
                            .catch((error) =>
                            {
                                return error;
                            })
                    }
                } else
                {
                    user = Object.assign(user, data);
                    this.changeState('verifyContact', user);
                }
            });
    }

    async signIn(e)
    {
        e.preventDefault();
        const username = this.inputs.username.toLowerCase();
        const password = this.inputs.password;
        if (!Auth || typeof Auth.signIn !== 'function')
        {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        this.setState({loading: true});
        try
        {
            const user = await Auth.signIn(username, password);
            if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA')
            {
                this.changeState('confirmSignIn', user);
            } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED')
            {
                this.changeState('requireNewPassword', user);
            } else if (user.challengeName === 'MFA_SETUP')
            {
                this.changeState('TOTPSetup', user);
            } else
            {
                this.checkContact(user);
            }
        } catch (err)
        {
            if (err.code === 'UserNotConfirmedException')
            {
                this.changeState('confirmSignUp', {username});
            } else if (err.code === 'PasswordResetRequiredException')
            {
                this.changeState('forgotPassword', {username});
            } else if (err.code === 'UserNotFoundException')
            {
                toast.error("Benutzername oder Kennwort falsch.");
            } else if (err.code === 'NotAuthorizedException')
            {
                toast.error("Benutzername oder Kennwort falsch.");
            } else
            {
                toast.error("Es ist ein unbekannter Fehler aufgetreten. Bitte kontaktieren Sie den Support.");
            }
        } finally
        {
            this.setState({loading: false})
        }
    }

    showComponent()
    {
        const {classes} = this.props;
        return (
            <MuiThemeProvider theme={AmplifyTheme}>
                <CssBaseline/>
                <div className={classes.main}>
                    <ToastContainer/>
                    <Paper className={classes.paper}>
                        <img src={Logo} width="200" height="200" alt="QRsticker logo"/>
                        <Typography component="h1" variant="h5" className={classes.title}>
                            {I18n.get('Sign In')}
                        </Typography>
                        <form className={classes.form} onSubmit={this.signIn}>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="username">{I18n.get('E-Mail Adresse')}</InputLabel>
                                <Input id="username" key="username" name="username" autoComplete="email" autoFocus autoCorrect="off" autoCapitalize="off"
                                       spellCheck="false" onChange={this.handleInputChange}/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">{I18n.get('Password')}</InputLabel>
                                <Input name="password" key="password" type="password" id="password" autoComplete="password" onChange={this.handleInputChange}/>
                            </FormControl>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}>
                                {I18n.get('Sign In')}
                            </Button>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={() => this.changeState("forgotPassword")}>
                                {I18n.get('Passwort vergessen')}
                            </Button>
                            <hr/>
                            <Typography>{I18n.get('Sie haben noch keinen Account?')}</Typography>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={() => this.changeState("signUp")}>
                                {I18n.get('Sign Up')}
                            </Button>
                        </form>
                    </Paper>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(AmplifyTheme)(CustomSignIn);
